export default "__VITE_ASSET__BrH4sC9i__"